/** @format */

import config from 'config.json';
import LanguageContainer from './languagePicker/LanguageContainer';
import NavigationContainer from './navigation/NavigationContainer';
import { ContextHolder } from '@frontegg/react';
import { useAppSelector } from 'utils/hooks/redux';
import { useDispatch } from 'react-redux';
import sessionActions from 'actions/session';

const Layout = () => {
  const useFrontegg = config.frontegg.enabled;
  const session = useAppSelector((state) => state.session);
  const { loggedIn } = session.toJS();

  const dispatch = useDispatch();
  const logout = () => {
    const baseUrl = ContextHolder.for().getContext().baseUrl;
    window.location.href = `${baseUrl}/oauth/logout?post_logout_redirect_uri=${window.location.origin}`;
    dispatch(sessionActions.logout());
  };
  return loggedIn || config.homePage !== 'addsecure' ? (
    <>
      <LanguageContainer />
      <NavigationContainer loggedIn={loggedIn} logout={useFrontegg && logout} />
    </>
  ) : (
    <></>
  );
};

export default Layout;
